module.exports = __webpack_public_path__ + "img/header.18f17ea2.png";